import { getStore } from '../store/store';
import { SubCategoryState, OptionSubCategory } from 'owa-options-core';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setSubCategoryState', async function setSubCategoryState(
    subCategory: OptionSubCategory,
    subCategoryState: SubCategoryState
) {
    const store = getStore();
    store.subCategoryLoadState.set(subCategory.key, subCategoryState);
});
